import {BrowserRouter as Router, useHistory, useLocation} from "react-router-dom";
import {toRelativeUrl} from "@okta/okta-auth-js";
import {Security} from "@okta/okta-react";
import {oktaAuth} from "../../services/okta/auth";
import {useEffect} from "react";

const OktaRouterSecurity = ({children}) => {
	const history = useHistory();

	const customAuthHandler = () => {
		history.push('/auth/default/login');
	};

	const restoreOriginalUri = (_oktaAuth, originalUri) => {
		history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
	};

	return (
		<Security
			oktaAuth={oktaAuth}
			onAuthRequired={customAuthHandler}
			restoreOriginalUri={restoreOriginalUri}
		>
			{children}
		</Security>
	);
};

const PageDetect = () => {
	const location = useLocation();

	useEffect(() => console.log('Render route: ', location.pathname), [location])

	return <></>
}

const OktaRouter = ({children}) => {


	return (
		<Router>
			<PageDetect/>
			<OktaRouterSecurity>
				{children}
			</OktaRouterSecurity>
		</Router>
	);
};

export default OktaRouter;
